import { Directive, Input, HostListener } from '@angular/core';
import { MemberInfo } from '../../../entities';
import { StyxMemberCardComponent } from './member-card.component';
import { UtilService } from '../../../utils';

@Directive({
    selector: '[styxMemberCardTrigger]'
})
export class StyxMemberCardTriggerDirective {
    @Input() styxMemberCardTrigger: MemberInfo;

    constructor(private util: UtilService) {}

    @HostListener('click', ['$event'])
    onClick(event: Event) {
        this.util.pbox.show(StyxMemberCardComponent, {
            target: event.currentTarget,
            initialState: {
                member: this.styxMemberCardTrigger
            }
        });
    }
}
